










import { Vue, Component } from 'vue-property-decorator';
import AlertasPantalla from './AlertasPantalla.vue';

@Component({
  components: { AlertasPantalla },
})
export default class ReportePantalla extends Vue {}
